import React, {useState, useEffect} from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";


const InstituteCreateNewPasswordPopup = ({setOpenSignupScreen, InstituteData }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [bothPasswordError, setBothPasswordError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const isPasswordValid = (password) => password.length >= 8;

  const validatePassword = (password) => {
    const errors = [];
  
    if (password.length < 8) {
      errors.push("Password must be at least 8 characters.");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("Password must include at least one uppercase letter.");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("Password must include at least one lowercase letter.");
    }
    if (!/[0-9]/.test(password)) {
      errors.push("Password must include at least one number.");
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      errors.push("Password must include at least one special character.");
    }
  
    return errors;
  };
  

    // const matchBothPasswords = async () => {
    //   // Validate new password and confirm password match
    //   setBothPasswordError("")
    //   if (newPassword !== confirmPassword) {
    //     setBothPasswordError("Passwords do not match.");
    //     return;
    //   }
    
    //   if (!isPasswordValid(newPassword)) {
    //     setBothPasswordError("Password must be at least 8 characters.");
    //     return;
    //   }
    // };


    const matchBothPasswords = () => {
      setBothPasswordError("");
      const errors = validatePassword(newPassword);
    
      if (newPassword !== confirmPassword) {
        errors.push("Passwords do not match.");
      }
    
      if (errors.length > 0) {
        setBothPasswordError(errors.join(" "));
        return false;
      }
    
      return true;
    };

    
    const handleChangePassword = async () => {
      // Reset messages
      setErrorMessage("");
      setSuccessMessage("");
      setBothPasswordError("");

      const isValid = matchBothPasswords(); // reuse the function

      if (!isValid) return;

      // if (newPassword !== confirmPassword) {
      //   setBothPasswordError("Passwords do not match.");
      //   return;
      // }
    
      // if (!isPasswordValid(newPassword)) {
      //   setBothPasswordError("Password must be at least 8 characters.");
      //   return;
      // }

        const UserId= InstituteData?.UserId;
        const userEmail= InstituteData?.email;
      try {
        // Send data to backend
        const response = await fetch("/api/institute/change-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ newPassword, UserId, userEmail }),
        });
  
        const result = await response.json();
  
        if (response.ok) {
            setOpenSignupScreen("PasswordSuccessScreen")

        } else {
          setErrorMessage(result.message || "An error occurred.");
        }
      } catch (error) {
        setErrorMessage("An error occurred. Please try again.");
      }
    };

    return (
        <div className="">
          <h2
            className=" mb-2 text-center text-[18px]"
          >
            Create New Password
          </h2>
          <p className="text-center text-[14px]">Enter a new password below to login to your account.</p>
          <div className="w-full flex flex-col gap-[10px] mt-[10px]">
                <div className="flex justify-between">
                    <label
                        htmlFor="New Password"
                        className="text-[#404040] text-[16px]"
                    >
                        Enter New Password
                    </label>
                </div>
                <div className="relative">
                  <input
                      type={showNewPassword ? "text" : "password"}
                      id="New Password"
                      placeholder="Enter New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      onBlur={matchBothPasswords} // Validate on blur
                      className={`w-[100%] rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                  />
                 <span
                      className="absolute top-[45%] right-[10px] transform -translate-y-1/2 cursor-pointer"
                      onClick={() => setShowNewPassword((prev) => !prev)}
                    >
                    {showNewPassword ? <AiFillEyeInvisible  size={20} /> : <AiFillEye size={20} />}
                  </span>
                  </div>
         </div>
         <div className="w-full flex flex-col gap-[10px] mt-[10px]">
          <div className="relative">
                <label
                    htmlFor="New Password"
                    className="text-[#404040] text-[16px]"
                >
                    Re Enter New Password
                </label>
                <input
                     type={showConfirmPassword ? "text" : "password"}
                    id="New Password"
                    placeholder="Re-enter New Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onBlur={matchBothPasswords} // Validate on blur
                    className={`w-[100%] rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                />
                <span
                    className="absolute top-[65%] right-[10px] transform -translate-y-1/2 cursor-pointer"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                  >
                    {showConfirmPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                  </span>
          </div>
          {bothPasswordError && <p className="text-[#ff0000] text-[16px] w-[360px]">{bothPasswordError}</p>}
          <p className="text-[15px] w-[360px] lg:w-[360px] ">Please create a secure password that is exactly 8 characters long and includes at least one uppercase letter, one number, and one special character.</p>
         </div>

          <div className="w-full flex justify-center items-center gap-[15px] mt-[20px]">
            <button
                className="py-[7px] w-[100px] rounded-[6px] text-[#A1A3EF] text-[14px] cursor-pointer"
                style={{border:"2px solid #A1A3EF"}}
                onClick={() => {
                    const isLocalhost = window.location.hostname === "localhost";
                    window.location.href = isLocalhost
                    ? "http://localhost:3000"
                    : "https://vehiclelearning.com/"; // Replace with your live site URL
                }}
                >
               Cancel
            </button>
            <button
                className="px-[15px] py-[7px] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleChangePassword}
                style={{border:"2px solid #A1A3EF"}}>
               Create Password
            </button>
          </div>
        </div>
    );
  };

export default InstituteCreateNewPasswordPopup;
